module.exports = __webpack_public_path__ + "img/bx09-1.8e5e0863.jpg";